import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SectionHeader from '../ui/SectionHeader';
import { api } from '../../lib/api';
import { normalizeAuthors } from '../../lib/normalizers';
import { formatCompactNumber } from '../../utils/format';

export default function TopAuthors() {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/users/authors')
      .then((data) => {
        if (!cancelled) setAuthors(normalizeAuthors(data.authors).slice(0, 5));
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (!loading && authors.length === 0) return null;

  return (
    <section className="container-app py-10">
      <SectionHeader chapter="10" title="Top Authors" subtitle="Writers our readers keep coming back to." to="/authors" />
      <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {loading && Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="card-surface flex flex-col items-center gap-3 p-5">
            <div className="h-16 w-16 rounded-full skeleton" />
            <div className="h-4 w-24 skeleton rounded" />
            <div className="h-3 w-16 skeleton rounded" />
          </div>
        ))}
        {!loading && authors.map((author, i) => (
          <motion.div
            key={author.id}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
          >
            <Link
              to={`/authors/${author.slug}`}
              className="card-surface flex flex-col items-center gap-3 p-5 text-center transition-shadow hover:shadow-soft-lg"
            >
              <img src={author.avatar} alt={author.name} className="h-16 w-16 rounded-full object-cover ring-4 ring-primary-50 dark:ring-white/10" />
              <div>
                <p className="font-display font-semibold text-sm text-slate-800 dark:text-white">{author.name}</p>
                <p className="text-xs text-slate-500 dark:text-slate-400">{formatCompactNumber(author.followers)} followers</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
